import React from 'react';

const DonationTiers = ({ selectedAmount, onSelectAmount }) => {
    const donationTiers = [
        { amount: 1500, title: "Hall of Fame", icon: "🏆" },
        { amount: 1000, title: "Legacy Sponsor", icon: "⭐" },
        { amount: 750, title: "All-Star Sponsor", icon: "🌟" },
        { amount: 500, title: "Captain Sponsor", icon: "👑" },
        { amount: 250, title: "Championship Sponsor", icon: "🥇" },
        { amount: 150, title: "MVP Sponsorship", icon: "🏅", isTarget: true },
        { amount: 100, title: "All-State Sponsor", icon: "🎯" },
        { amount: 75, title: "Season Supporter", icon: "📅" },
        { amount: 50, title: "Contributor Sponsor", icon: "🤝" },
        { amount: 35, title: "Team Sponsor", icon: "👥" }
    ];

    return (
        <div className="donation-tiers-container">
            <h4 className="mb-3">Choose Your Sponsorship Level</h4>
            <div className="row g-2">
                {donationTiers.map((tier) => {
                    const isSelected = selectedAmount === tier.amount;
                    const isTarget = tier.isTarget;
                    
                    return (
                        <div key={tier.amount} className="col-6 col-md-4 col-lg-3">
                            <div 
                                className={`donation-tier-card ${isSelected ? 'selected' : ''}`}
                                onClick={() => onSelectAmount(tier.amount)}
                                style={{
                                    cursor: 'pointer',
                                    border: '2px solid',
                                    borderColor: isSelected ? '#0e456c' : '#dee2e6',
                                    borderRadius: '8px',
                                    padding: window.innerWidth < 768 ? '10px 8px' : '15px 12px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: isSelected ? '#f0f7ff' : 'white',
                                    boxShadow: isSelected ? '0 4px 8px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)',
                                    position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isSelected) {
                                        e.currentTarget.style.borderColor = '#6c757d';
                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isSelected) {
                                        e.currentTarget.style.borderColor = '#dee2e6';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }
                                }}
                            >
                                {/* Target badge for MVP sponsorship */}
                                {isTarget && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        backgroundColor: '#6c757d',
                                        color: '#fff',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                        ★
                                    </div>
                                )}
                                
                                <div style={{ 
                                    fontSize: window.innerWidth < 768 ? '1.2em' : '1.5em', 
                                    marginBottom: window.innerWidth < 768 ? '5px' : '8px' 
                                }}>
                                    {tier.icon}
                                </div>
                                <h6 style={{ 
                                    color: '#0e456c', 
                                    marginBottom: window.innerWidth < 768 ? '4px' : '8px',
                                    fontSize: window.innerWidth < 768 ? '0.9rem' : '1rem',
                                    fontWeight: 'bold'
                                }}>
                                    ${tier.amount}
                                </h6>
                                <p style={{ 
                                    margin: 0, 
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    fontSize: window.innerWidth < 768 ? '0.75rem' : '0.85rem',
                                    lineHeight: window.innerWidth < 768 ? '1.2' : '1.3'
                                }}>
                                    {tier.title}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DonationTiers; 